export default __webpack_public_path__ + "static/media/803.de773a1b.png";